module.exports = __webpack_public_path__ + "img/barley.be5030ca.webp";